import { globalTheme } from '@cld/component-theme';
import { theme } from './theme';

export type SpacingType = 'none' | 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

export const getCssPadding = (direction: 'vertical' | 'horizontal', spacing?: SpacingType) => {
  if (spacing === undefined) {
    return theme.padding[direction];
  }
  if (spacing === 'none') {
    return '0';
  }
  return globalTheme.spacing[spacing];
};
